import axios from 'axios'
import store from '@/store/store'
import { getToken, setToken, removeToken } from '@/store/getToken'
import Message from 'muse-ui'
import { JPT_URL } from '@/config/constant'

// 创建axios实例
const service = axios.create({
  baseURL: JPT_URL,
  timeout: 60000 // 请求超时时间
})

// http request 拦截器
service.interceptors.request.use(

  config => {
  // Do something before request is sent
    if (getToken()) {
      config.headers['Authorization'] = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    }
    return config
  }, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  })

// http response 拦截器
service.interceptors.response.use(
  function (response) {
    // 请求正常则返回
    var status = response.status
    var resData = response.data
    // 没有权限
    if (status === 401) {
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeToken()
        sessionStorage.removeItem('user')
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
      return Promise.reject('error')
    } else if (status !== 200) {
      return Promise.reject('error')
    } else {
      return resData
    }
  },
  function (error) {
    // 请求错误则向store commit这个状态变化
    const httpError = {
      hasError: true,
      status: error.request.status,
      statusText: error.request.statusText
    }
    store.commit('ON_HTTP_ERROR', httpError)
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/axios/promise.js